import { createFileRoute, useParams } from "@tanstack/react-router";
import { PurchaseOrderDetailPage } from "@/components/inventory/PurchaseOrderDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/purchase-orders_/$id")({
  component: AdminPurchaseOrderDetail,
});

function AdminPurchaseOrderDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/purchase-orders_/$id" });
  return <PurchaseOrderDetailPage poId={id} />;
}
